<template>
    <div :id="'radio--' + component_id">
        <div v-if="options_loaded && passed_filter && show_laminated_option" class="designeroption">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>{{ title }}</span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionDoorGlassLaminated from "../DesignerQuestionDoorGlassLaminated.vue";
    import SynsealRadioQuestion from "../mixin/synseal/RadioQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorGlassLaminated,
            SynsealRadioQuestion,
        ],
        props: {
            securedByDesign: {
                required: true,
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/laminated-glass?secured_by_design=' + this.securedByDesign + '&slab=' + this.slab + '&left=' + this.get_side('left') + '&right=' + this.get_side('right') + '&top=' + this.get_side('top') + '&comp_left=' + this.get_side('left_composite_id') + '&comp_right=' + this.get_side('right_composite_id');
            },
            passed_filter(){
                return this.variable_ready(this.securedByDesign, this.slab, this.frameStyle, this.sidePanels);
            },
            cache_key(){
                return '_' + this.securedByDesign + '_' + this.slab + '_' + this.get_side('left') + '_' + this.get_side('right') + '_' + this.get_side('top') + '_' + this.get_side('left_composite_id') + '_' + this.get_side('right_composite_id');
            },
        },
        watch: {
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            }
        }
    }
</script>
